import { useMemo } from 'react';

interface ReadinessScoreProps {
  score: number;
}

export default function ReadinessScore({ score }: ReadinessScoreProps) {
  const color = useMemo(() => {
    if (score >= 90) return 'text-blue-600';
    if (score >= 80) return 'text-green-600';
    if (score >= 70) return 'text-yellow-600';
    return 'text-red-600';
  }, [score]);

  const status = useMemo(() => {
    if (score >= 90) return 'Excellent';
    if (score >= 80) return 'Good';
    if (score >= 70) return 'Fair';
    return 'Needs Improvement';
  }, [score]);

  const insight = useMemo(() => {
    if (score >= 90) return 'All systems optimal';
    if (score >= 80) return 'Good, but training gaps remain';
    if (score >= 70) return 'Several areas need attention';
    return 'Immediate action required';
  }, [score]);

  const strokeColor = useMemo(() => {
    if (score >= 90) return '#2563EB';
    if (score >= 80) return '#059669';
    if (score >= 70) return '#D97706';
    return '#DC2626';
  }, [score]);

  return (
    <div className="bg-white rounded-lg shadow h-[250px]">
      <div className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-baseline">
              <p className={`text-4xl font-bold ${color}`}>
                {score}
              </p>
              <span className="text-2xl text-gray-500 ml-1">/100</span>
            </div>
            <h4 className="text-lg font-medium mt-2">
              {status}
            </h4>
            <p className="text-gray-600 mt-1">
              {insight}
            </p>
          </div>
          <div className="w-32 h-32 relative">
            <svg className="w-full h-full" viewBox="0 0 36 36">
              <path
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke="#E5E7EB"
                strokeWidth="3"
              />
              <path
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke={strokeColor}
                strokeWidth="3"
                strokeDasharray={`${score}, 100`}
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}